import { shortConstructedResponseOptions } from '../modules/tei/data/constructed-response-options';
import { PopulationConstructedResponse } from '../shared/interfaces/population-constructed-response';
import { TEST_CHOICE_TYPES } from './choice-types';
import { CHART_TYPES, charts } from './charts';
import { TestAssociatedSuccessCriteria } from './test-associated-success-criteria.enum';

export const constructedResponseQuestions: {
  [key: number]: PopulationConstructedResponse;
} = {
  [TEST_CHOICE_TYPES.TEST_R_SCR_SHORT]: {
    text: {
      text: 'This is the activity constructed response short question?',
    },
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_R_SCR_MEDIUM]: {
    text: {
      text: 'This is the activity constructed response medium question? Added question text for medium length.',
    },
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_R_SCR_LONG]: {
    text: {
      text: 'This is the activity constructed response long question? Added text to the question in order to add longer question. More question text added here for length.',
    },
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_R_SCRR_SHORT]: {
    text: {
      text: 'This is the activity constructed response with rubric short question?',
    },
    chart: charts[CHART_TYPES.SAMPLE_WITH_TITLE],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE_RUBRIC,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_R_SCRR_MEDIUM]: {
    text: {
      text: 'This is the activity constructed response with rubric medium question? Added question text for medium length.',
    },
    chart: charts[CHART_TYPES.SAMPLE_WITH_TITLE],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE_RUBRIC,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_R_SCRR_LONG]: {
    text: {
      text: 'This is the activity constructed response with rubric long question? Added text to the question in order to add longer question. More question text added here for length.',
    },
    chart: charts[CHART_TYPES.SAMPLE_WITHOUT_TITLE],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE_RUBRIC,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_S_SCR_SHORT]: {
    text: {
      text: '¿Esta es la pregunta corta de respuesta construida de la actividad?',
    },
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_S_SCR_MEDIUM]: {
    text: {
      text: '¿Esta es la pregunta media de respuesta construida de actividad? Se agregó texto de pregunta para longitud media.',
    },
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_S_SCR_LONG]: {
    text: {
      text: '¿Esta es la pregunta larga de respuesta construida de la actividad? Se agregó texto a la pregunta para agregar una pregunta más larga. Se agregó más texto de pregunta aquí para mayor extensión.',
    },
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_S_SCRR_SHORT]: {
    text: {
      text: '¿Esta es la respuesta construida de la actividad con rúbrica de pregunta corta?',
    },
    chart: charts[CHART_TYPES.EXPERIMENTAL],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE_RUBRIC,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_S_SCRR_MEDIUM]: {
    text: {
      text: '¿Esta es la respuesta construida de la actividad con pregunta media de rúbrica? Se agregó texto de pregunta para longitud media.',
    },
    chart: charts[CHART_TYPES.SAMPLE_WITH_TITLE],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE_RUBRIC,
    ],
    options: shortConstructedResponseOptions,
  },
  [TEST_CHOICE_TYPES.TEST_S_SCRR_LONG]: {
    text: {
      text: '¿Esta es la respuesta construida de la actividad con una rúbrica de pregunta larga? Se agregó texto a la pregunta para agregar una pregunta más larga. Se agregó más texto de pregunta aquí para mayor extensión.',
    },
    chart: charts[CHART_TYPES.SAMPLE_WITH_TITLE],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.SHORT_CONST_RESPONSE_RUBRIC,
    ],
    options: shortConstructedResponseOptions,
  },
};
